import React, { useCallback, useEffect } from 'react'
import ActionButtons from '../components/ActionButtons'
import GroupTable from './GroupTable/index'
import _ from 'lodash'
import { useSelector } from 'react-redux'
import ReactRouterPrompt from 'react-router-prompt'
import UnsavedDataPopup from '../../../components/UnsavedDataPopup'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '../../../util/axios'
import axios from 'axios'

export default function AdminPanelGroups({}) {
	const [groupData, setGroupData] = React.useState([])
	const [oldGroupData, setOldGroupData] = React.useState([])
	const [workingOnPage, setWorkingOnPage] = React.useState(false) //required to prevent user actions when data is being updated in background
	const ownGroup = useSelector((state) => state.user.value.group.id)
	const navigate = useNavigate()

	const hasChanged = useCallback(() => {
		return !_.isEqual(groupData, oldGroupData)
	}, [groupData, oldGroupData])

	function reloadData() {
		const groupPromise = axiosInstance.get('/api/groups').then((groupList) => {
			return groupList['hydra:member']
		})
		const userPromise = axiosInstance.get('/api/users').then((userList) => {
			return userList['hydra:member']
		})

		Promise.all([groupPromise, userPromise]).then((lists) => {
			const groupList = lists[0]
			const userList = lists[1]
			setContainsUserFlag(groupList, userList)
		})
	}

	const setContainsUserFlag = (groupList, userList) => {
		for (const group of groupList) {
			const groupUser = userList.find((user) => user.groupId === group.id)
			group.containsUser = !!groupUser
		}
		setGroupData(groupList)
		setOldGroupData(_.cloneDeep(groupList))
	}

	useEffect(() => {
		reloadData()
	}, [])

	useEffect(() => {
		if (hasChanged()) {
			window.addEventListener('beforeunload', alertUser)
			return () => {
				window.removeEventListener('beforeunload', alertUser)
			}
		}
	}, [hasChanged])

	const alertUser = (e) => {
		e.preventDefault()
		e.returnValue = ''
	}

	const onAddEntryButtonPress = () => {
		const element = {
			name: '',
			permissionData: {
				admin: false,
				read: false,
				read_owner: false,
				read_owner_names: false,
				read_artist: false,
				read_artist_names: false,
				read_artwork: false,
				write: false,
				write_own: false,
				fe_read: [],
				fe_write: [],
			},
		}
		setGroupData((state) => [...state, element])
	}

	const onSaveButtonPress = () => {
		if (workingOnPage) return

		const promiseList = []

		//check delete
		for (const group of oldGroupData) {
			const currentGroup = groupData.find((e) => e.id == group.id)
			if (!currentGroup) {
				promiseList.push(axiosInstance.delete(`/api/groups/${group.id}`))
			}
		}

		//check update/create
		for (const group of groupData) {
			if (group.id) {
				if (group.id == ownGroup) continue
				const oldGroup = oldGroupData.find((e) => e.id === group.id)
				if (!_.isEqual(oldGroup, group)) {
					promiseList.push(
						axiosInstance.patch(`/api/groups/${group.id}`, group)
					)
				}
			} else {
				promiseList.push(axiosInstance.post('/api/groups', group))
			}
		}

		setWorkingOnPage(true)

		Promise.all(promiseList).then(
			(values) => {
				reloadData()
				setWorkingOnPage(false)
			},
			(reason) => {
				switch (reason.type) {
					case 'NotLoggedInException':
						navigate('/login')
						break

					default:
						alert('Beim Speichern ist ein Fehler aufgetreten.')
				}
				setWorkingOnPage(false)
			}
		)
	}

	return (
		<>
			<ReactRouterPrompt when={hasChanged()}>
				{({ isActive, onConfirm, onCancel }) => (
					<UnsavedDataPopup
						open={isActive}
						onConfirm={onConfirm}
						onCancel={onCancel}
					/>
				)}
			</ReactRouterPrompt>
			<div className='tableContainer'>
				<GroupTable data={groupData} setData={setGroupData} />
			</div>
			<p>
				*) Nutzergruppen können nicht gelöscht werden, wenn es Nutzer gibt, die
				Teil dieser Gruppe sind. Aus diesem Grund ist der "Löschen" Button bei
				einigen Nutzergruppen ausgegraut.
			</p>
			<ActionButtons
				onAddButtonPress={onAddEntryButtonPress}
				onSaveButtonPress={onSaveButtonPress}
				pageHasUnsavedChanges={hasChanged}
			/>
		</>
	)
}
